/**
 * Purchase Orders Reducer
 * Initial state and action handler for purchase orders list
 */

const initialState = { data: [], loading: true };

export const GetAllPurchaseOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_purchase_orders":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

// Initial purchase order data structure (for form default values)
export const purchaseOrderDataState = {
  PurchaseOrderId: 0,
  PONumber: null,
  VendorId: null,
  TotalAmount: null,
  Status: "Pending",
  OrderDate: null,
  Items: [],
};
